import React, { useState, useEffect } from 'react';
import './Disclaimer.css';
import Logo from './Logo';

const Disclaimer = ({ onAccept }) => {
  const [showItems, setShowItems] = useState([false, false, false]);

  useEffect(() => {
    // Animate items in sequence
    const timer1 = setTimeout(() => setShowItems([true, false, false]), 300);
    const timer2 = setTimeout(() => setShowItems([true, true, false]), 600);
    const timer3 = setTimeout(() => setShowItems([true, true, true]), 900);

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
      clearTimeout(timer3);
    };
  }, []);

  return (
    <div className="disclaimer-container">
      <div className="disclaimer-content">
        {/* Logo and Brand */}
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <div style={{ marginBottom: '1rem' }}>
            <Logo size="4rem" />
          </div>
          <h2 style={{ 
            fontSize: '1.5rem', 
            fontWeight: '600', 
            color: '#133153', 
            margin: '0 0 0.5rem 0' 
          }}>
            S.U.E.
          </h2>
          <p style={{ 
            fontSize: '1rem', 
            color: 'var(--color-text-secondary)', 
            margin: '0' 
          }}>
            Sexuality Understanding & Education
          </p>
        </div>

        {/* Lock Icon */}
        <div className="lock-icon">
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 1C15.309 1 18 3.691 18 7V10H19C20.1046 10 21 10.8954 21 12V20C21 21.1046 20.1046 22 19 22H5C3.89543 22 3 21.1046 3 20V12C3 10.8954 3.89543 10 5 10H6V7C6 3.691 8.691 1 12 1ZM12 3C9.79086 3 8 4.79086 8 7V10H16V7C16 4.79086 14.2091 3 12 3Z" fill="#5b6bc0"/>
          </svg>
        </div>

        {/* Title */}
        <h1 className="disclaimer-title">Rest assured — everything you share here is private and secure.</h1>
        
        {/* Subtitle */}
        <p className="disclaimer-subtitle">
          You're in a safe, anonymous space.
        </p>

        {/* Privacy Points */}
        <div className="privacy-points">
          <div className={`privacy-item ${showItems[0] ? 'animate-in' : ''}`}>
            <span className="checkmark">🔒</span>
            <span>We will never sell your data, track your location, or ask for identifying information.</span>
          </div>
          
          <div className={`privacy-item ${showItems[1] ? 'animate-in' : ''}`}>
            <span className="checkmark">👀</span>
            <span>No one is watching this chat in real time — you're in a safe, anonymous space.</span>
          </div>
          
          <div className={`privacy-item ${showItems[2] ? 'animate-in' : ''}`}>
            <span className="checkmark">📖</span>
            <span>This tool is for general education only — not a substitute for medical advice.</span>
          </div>
        </div>

        {/* Accept Button */}
        <button 
          className="accept-button"
          onClick={onAccept}
          disabled={!showItems[2]}
        >
          I Understand
        </button>

        {/* Bot Character */}
        <div className="bot-character">
          <div className="bot-face">
            <span className="bot-eyes">◯ ◡ ◯</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Disclaimer; 